import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { Row, Col } from 'antd';
import useMobile from '@/hooks/useMobile';
import { Modal, FreeForm, FormItem, Form, Button, TextArea } from 'iglooform';

import './index.less';

interface IProps {
  visible: boolean;
  initValue?: any;
  onCancel: any;
  onConfirm: (amount: any) => any;
}

const ModalNote = (props: IProps) => {
  const { visible, onCancel, onConfirm, initValue } = props;
  const isMobile = useMobile();
  const form = Form.useForm();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (initValue) {
      const { note } = initValue;
      form.setFieldsValue({ note });
    }
  }, [initValue]);

  return (
    <>
      {visible && (
        <Modal
          destroyOnClose
          visible={visible}
          onCancel={onCancel}
          closable
          title={formatMessage({ id: 'Note' })}
          footer={
            <Row justify="end" style={{ width: '100%' }}>
              <Col {...(isMobile ? { span: 24 } : {})}>
                <Button
                  style={isMobile ? { width: '100%' } : {}}
                  type="primary"
                  onClick={async () => {
                    const formValue = await form.validateFields();
                    onConfirm({
                      ...formValue,
                    });
                    onCancel();
                  }}
                >
                  {formatMessage({ id: 'Confirm' })}
                </Button>
              </Col>
            </Row>
          }
        >
          <FreeForm form={form}>
            <FormItem
              required={false}
              fullRow
              name="note"
              placeholder={formatMessage({ id: 'Note to customer (Optional)' })}
            >
              <TextArea />
            </FormItem>
          </FreeForm>
        </Modal>
      )}
    </>
  );
};

export default ModalNote;
